import { collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '@/lib/firebase'
import { forwardSignalToPilot } from './mock-api'

export interface SignalInput {
  symbol: string
  side: 'LONG' | 'SHORT'
  entry: number
  sl: number
  tp: number
  rr: number
  status: 'active' | 'pending' | 'closed' | 'observation' | 'target-hit' | 'stop-hit'
  timeframe?: string
  confidence?: number
  strategy?: string
  validity?: string
}

export async function createSignal(signalData: SignalInput) {
  if (!db) {
    throw new Error('Firestore is not initialized. Please check your .env.local file.')
  }

  try {
    const docRef = await addDoc(collection(db, 'signals'), {
      ...signalData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    })
    
    console.log('Signal created with ID:', docRef.id)
    return docRef.id
  } catch (error) {
    console.error('Error creating signal:', error)
    throw error
  }
}

export async function sendSignalToPilot(signalId: string, signalData: SignalInput) {
  try {
    const result = await forwardSignalToPilot({
      signalId,
      symbol: signalData.symbol,
      side: signalData.side,
      entry: signalData.entry,
      sl: signalData.sl,
      tp: signalData.tp,
      rr: signalData.rr,
    })

    console.log('Signal sent to Pilot successfully:', result)
    return result
  } catch (error) {
    console.error('Error sending signal to Pilot:', error)
    throw error
  }
}

export async function sendSignalToWebhook(signalData: SignalInput) {
  const webhookUrl = import.meta.env.VITE_N8N_WEBHOOK_URL
  
  if (!webhookUrl) {
    throw new Error('Webhook URL not configured')
  }

  try {
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(signalData),
    })

    if (!response.ok) {
      throw new Error('Failed to send signal to webhook')
    }

    const result = await response.json()
    console.log('Signal sent to webhook successfully:', result)
    return result
  } catch (error) {
    console.error('Error sending signal to webhook:', error)
    throw error
  }
}
